import { gql } from "@apollo/client";

export const CONFIG_ELEMENT_FRAGMENT = gql`
  fragment configElement on ConfigElement {
    createdAt
    id
    description
    runtime
    type
    value
    writeOnly
  }
`;

export const ADD_ENVIRONMENT_CONFIG = gql`
  mutation AddEnvironmentConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;

export const UPDATE_ENVIRONMENT_CONFIG = gql`
  mutation UpdateEnvironmentConfig($stackId: ID!, $input: ConfigInput!) {
    stackConfigAdd(stack: $stackId, config: $input) {
      id
      type
    }
  }
`;

export const DELETE_ENVIRONMENT_CONFIG = gql`
  mutation DeleteEnvironmentConfig($stackId: ID!, $configId: ID!) {
    stackConfigDelete(stack: $stackId, id: $configId) {
      id
      type
    }
  }
`;
